import { GetterTree } from 'vuex'
import { ContactInfoState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ContactInfoState, RootState> = {}
